import React from "react";
import { UserCheck } from "lucide-react";

const EmptyState = ({ theme, t, searchTerm, setSearchTerm, setFilterStatus }) => {
  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        color: theme === "dark" ? "rgba(255,255,255,0.6)" : "#6b7280",
      }}
    >
      <UserCheck
        size={60}
        style={{ margin: "0 auto 16px", opacity: 0.6 }}
      />
      <h3
        style={{
          fontSize: "20px",
          fontWeight: "700",
          margin: "0 0 8px 0",
          color: theme === "dark" ? "rgba(255,255,255,0.8)" : "#374151",
        }}
      >
        {t.noRecordsFound}
      </h3>
      <p
        style={{
          fontSize: "14px",
          opacity: 0.8,
          color: theme === "dark" ? "rgba(255,255,255,0.6)" : "#6b7280",
        }}
      >
        {searchTerm ? `🔍 "${searchTerm}" - ${t.noRecordsMatch}` : t.noRecordsMatch}
      </p>
      {searchTerm && (
        <button
          onClick={() => {
            setSearchTerm("");
            setFilterStatus("all");
          }}
          style={{
            marginTop: "12px",
            padding: "8px 16px",
            background: "#3b82f6",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          ✕ {t.clearAll || "Clear"}
        </button>
      )}
    </div>
  );
};

export default EmptyState;